import { ReactElement } from "react";
import Layout from "../../components/layout";
import UserTransactionList from "../../components/Transaction";

const MyTransactionPage = (): ReactElement => {
  return (
    <Layout>
      <UserTransactionList />
    </Layout>
  );
};

export default MyTransactionPage;
